export enum ReportApplicationStatus {
    WAITING_FOR_KO = 'WAITING_FOR_KO',
    WAITING_FOR_RM = 'WAITING_FOR_RM',
    ACCEPTED = 'ACCEPTED',
    REJECTED_BY_KO = 'REJECTED_BY_KO',
    REJECTED = 'REJECTED'
}
